import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../firebase"; // adjust path if needed
import Navbar from '../components/Navbar';

function BookSummaryPage() {
  const { bookname } = useParams();
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(true);

  // Use your actual user fetching logic here!
  const user = JSON.parse(localStorage.getItem("user")) || {};

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setSummary("⚠️ Please log in to view summaries.");
      setLoading(false);
      return;
    }
    fetch("https://api-jrox57cr4q-uc.a.run.app/read-book", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uid: user.uid,
        bookname: decodeURIComponent(bookname),
        action: "summarize"
      }),
    })
      .then(res => res.json())
      .then(data => {
        setSummary(data.answer || "No summary available.");
        setLoading(false);
      });
  }, [bookname]);

  return (
     <>
        <Navbar />
    <div className="min-h-screen flex flex-col items-center bg-yellow-50">
      <div className="max-w-xl w-full bg-white p-8 mt-16 rounded-lg shadow-xl">
        <h1 className="text-2xl font-bold mb-4 text-yellow-800">📖 Book Summary</h1>
        {loading ? <div>Loading...</div> : <div className="text-gray-800 whitespace-pre-line">{summary}</div>}
      </div>
    </div>
    </>
  );
}

export default BookSummaryPage;
